export default {
feedback: {
  title: "Feedback",
  placeholder: "Deixe uma mensagem ({ contentLen }/1000 caracteres)",
  error: "Esta é uma mensagem de erro",
  uploadLimit: "Limite de upload de imagens e vídeos",
  send: "Enviar",
  tipTitle: "Ajude-nos a melhorar sua experiência",
  desc1: "Você pode enviar qualquer dúvida, e se for aceita, receberá um presente surpresa.",
  desc2: "Se não for conveniente pelo site, você também pode enviar por e-mail."
}
};
